<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: `SettingsClients`,
};
</script>

<style lang="scss">
</style>
